import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Create axios instance with interceptor
const api = axios.create({
  baseURL: API,
});

// Add interceptor to include user email in headers
api.interceptors.request.use((config) => {
  const user = localStorage.getItem('user');
  if (user) {
    try {
      const userData = JSON.parse(user);
      config.headers['X-User-Email'] = userData.email;
    } catch (e) {
      console.error('Error parsing user data:', e);
    }
  }
  return config;
});

export default api;
